const GalleryIcon = ({ fill = "#2BB792" }: { fill?: string }) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#a)">
            <path
                d="M20.999 18.999v-14c0-1.1-.9-2-2-2h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2Zm-12.1-5.02 2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68a.5.5 0 0 1-.4.8H6.019c-.42 0-.65-.48-.39-.81l2.49-3.2c.19-.26.57-.27.78-.02Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
)

export default GalleryIcon
